import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllMajorCategory } from '../../../redux/admin/category/category_services_syn';
import { useFormik } from 'formik';
import {
  CreateProduct,
  UploadProductImages,
} from '../../../redux/admin/product/product_services_syn';
import { toast } from 'react-toastify';
import {
  productFormikForm,
  productionSchema,
} from '../../../yups/product_yups';
import { InfinitySpin } from 'react-loader-spinner';
import { Skeleton } from '@mui/material';
import { updateProductImageDetails } from '../../../redux/admin/product/product_slices';
import { GetAllMajorBrand } from '../../../redux/admin/brand/brand_services_sync';
import ColorPicker from 'react-pick-color';

const tagStatus = [{ name: 'New Arrival' }, { name: 'Old Arrival' }];

const Create_Product = () => {
  const dispatch = useDispatch();

  const [images, setImages] = useState([]);

  const [currentColor, setCurrentColor] = useState('#ffffff');
  const [selectedColors, setSelectedColors] = useState([]);

  console.log(currentColor, selectedColors, 'selectedColors selectedColors');

  const { category_loader, completeMajorCategory } = useSelector(
    (state) => state.category
  );

  const { brand_loader, completeMajorBrand } = useSelector(
    (state) => state.brand
  );

  const {
    productEditLoader,
    product_loader,
    productImagesDetails,
    productthubnailDetails,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(GetAllMajorCategory());

    dispatch(GetAllMajorBrand());

    return () => {};
  }, []);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    console.log(productImagesDetails, productthubnailDetails, 'savid');
    if (product_loader) return;

    if (
      !Array.isArray(productImagesDetails) ||
      (typeof productImagesDetails === 'object' &&
        Object.keys(productImagesDetails).length === 0)
    ) {
      toast('Images and thumbnail missing, please click to add them');

      return;
    }

    const gallery = Array.isArray(productImagesDetails)
      ? productImagesDetails?.map((item) => {
          return {
            pic_url: item?.secure_url,
            pic_id: item?.public_id,
          };
        })
      : [
          {
            pic_url: productImagesDetails?.secure_url,
            pic_id: productImagesDetails?.public_id,
          },
        ];

    const payload = {
      ...value,
      colors: selectedColors,
      gallery: gallery,
      thumbnail_image_pic: productthubnailDetails?.secure_url,
      thumbnail_image_id: productthubnailDetails?.public_id,
    };

    dispatch(CreateProduct(payload));

    resetForm();

    dispatch(updateProductImageDetails([]));

    setSelectedColors([]);
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: productFormikForm,
    validationSchema: productionSchema,
    onSubmit: handleSubmited,
  });

  const handleProductImage = async (e) => {
    const image = e.target.files;

    if (image) {
      const formData = new FormData();

      Array.from(image).forEach((file, i) => {
        formData.append(`file`, file);
      });

      await dispatch(UploadProductImages(formData));

      setImages(image);
    }
  };

  const addColor = () => {
    if (selectedColors.length >= 6)
      return toast('You can select up to 6 colors only.');
    if (!selectedColors.includes(currentColor)) {
      setSelectedColors([...selectedColors, currentColor]);
    } else {
      toast('already added');
    }
  };

  const removeColor = (color) => {
    setSelectedColors(selectedColors.filter((c) => c !== color));
  };

  return (
    <>
      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <div class="card">
            <div class="card-body">
              {productImagesDetails[0]?.secure_url && (
                <img
                  src={productImagesDetails[0]?.secure_url}
                  alt=""
                  class="img-fluid rounded bg-light"
                />
              )}
              <div class="mt-3">
                {Array.from(images)?.map((item, key) => (
                  <h4 key={key}>{`${item.name}`}</h4>
                ))}
                <h5 class="text-dark fw-medium mt-3">Images:</h5>
                <h4 class="fw-semibold text-dark mt-2 d-flex align-items-center gap-2">
                  {Array.from(images).length}
                </h4>
              </div>
            </div>
            <div class="card-footer bg-light-subtle">
              <div class="row g-2">
                <div class="col-lg-6">
                  <a href="#!" class="btn btn-primary w-100">
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Add Product Photo</h4>
            </div>
            <div class="card-body">
              <form
                action="https://techzaa.in/"
                method="post"
                class="dropzone"
                id="myAwesomeDropzone"
                data-plugin="dropzone"
                data-previews-container="#file-previews"
                data-upload-preview-template="#uploadPreviewTemplate"
                style={{ position: 'relative' }}
              >
                <div class="fallback">
                  <input
                    name="file"
                    type="file"
                    multiple
                    onChange={handleProductImage}
                    style={{
                      border: '1px solid red',
                      position: 'absolute',
                      width: '98%',
                      height: '90%',
                      opacity: 0,
                    }}
                  />
                </div>
                <div class="dz-message needsclick cursor-pointer">
                  <i class="bx bx-cloud-upload fs-48 text-primary"></i>
                  <h3 class="mt-4">
                    Drop your images here, or{' '}
                    <span class="text-primary cursor-pointer">
                      click to browse
                    </span>
                  </h3>
                  <span class="text-muted fs-13 cursor-pointer">
                    {Array.from(images).length > 0 ? (
                      Array?.from(images)?.map((item, key) => (
                        <>{`${item.name}  `}</>
                      ))
                    ) : (
                      <>
                        1600 x 1200 (4:3) recommended. PNG, JPG and GIF files
                        are allowed
                      </>
                    )}
                  </span>
                </div>
              </form>
            </div>

            {productEditLoader && (
              <div class="form-group col-sm-9">
                <InfinitySpin width="100" color="#FE6B30" />
              </div>
            )}
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Product Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="product-name" class="form-label">
                        Product Name
                      </label>
                      <input
                        type="text"
                        id="product-name"
                        class="form-control"
                        placeholder="Product Name"
                        value={values.product_name || ''}
                        onChange={handleChange}
                        name="product_name"
                        style={{
                          border: errors.product_name && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
                <div class="col-lg-6">
                  {category_loader ? (
                    <Skeleton height={80} width={'100%'} count={1} />
                  ) : (
                    <form>
                      <label for="product-categories" class="form-label">
                        Product Categories
                      </label>
                      <select
                        class="form-control"
                        id="product-categories"
                        data-choices
                        data-choices-groups
                        data-placeholder="Select Categories"
                        name="choices-single-groups"
                        value={values.category || ''}
                        onChange={(e) =>
                          setFieldValue('category', e.target.value)
                        }
                        style={{
                          border: errors.category && '1px solid red',
                        }}
                      >
                        <option value="">Choose a categories</option>
                        {completeMajorCategory?.map((item, key) => (
                          <option key={key} value={item?.name}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </form>
                  )}
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  {brand_loader ? (
                    <Skeleton height={80} width={'100%'} count={1} />
                  ) : (
                    <form>
                      <label for="product-categories" class="form-label">
                        Product Brand
                      </label>
                      <select
                        class="form-control"
                        id="product-categories"
                        data-choices
                        data-choices-groups
                        data-placeholder="Select Brand"
                        name="choices-single-groups"
                        value={values.brand || ''}
                        onChange={(e) => setFieldValue('brand', e.target.value)}
                        style={{
                          border: errors.brand && '1px solid red',
                        }}
                      >
                        <option value="">Choose a brand</option>
                        {completeMajorBrand?.map((item, key) => (
                          <option key={key} value={item?.name}>
                            {item?.name}
                          </option>
                        ))}
                      </select>
                    </form>
                  )}
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-3">
                    <label for="description" class="form-label">
                      Description
                    </label>
                    <textarea
                      class="form-control bg-light-subtle"
                      id="description"
                      rows="7"
                      placeholder="Short description about the product"
                      value={values.description || ''}
                      onChange={handleChange}
                      name="description"
                      style={{
                        border: errors.description && '1px solid red',
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <form>
                    <label for="product-categories" class="form-label">
                      Product Tag
                    </label>
                    <select
                      class="form-control"
                      id="product-categories"
                      data-choices
                      data-choices-groups
                      data-placeholder="Select Tag"
                      name="choices-single-groups"
                      value={values.tags || ''}
                      onChange={(e) => setFieldValue('tags', e.target.value)}
                      style={{
                        border: errors.tags && '1px solid red',
                      }}
                    >
                      <option value="">Choose a tags</option>
                      {tagStatus?.map((item, key) => (
                        <option key={key} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </form>
                </div>
                <div class="col-lg-4">
                  <form>
                    <div class="mb-3">
                      <label for="product-stock" class="form-label">
                        Stock
                      </label>
                      <input
                        type="number"
                        id="product-stock"
                        class="form-control"
                        placeholder="Quantity"
                        value={values.quantity || ''}
                        onChange={handleChange}
                        name="quantity"
                        style={{
                          border: errors.quantity && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <ColorPicker
                    color={currentColor}
                    onChange={(updatedColor) =>
                      setCurrentColor(updatedColor.hex)
                    }
                  />
                </div>
                <div class="col-lg-4">
                  <button
                    onClick={addColor}
                    className="px-4 py-2 bg-[#FE6B30] text-white rounded hover:bg-[#fe6a30c4]"
                  >
                    Add Color
                  </button>

                  <div className="flex flex-wrap gap-2 mt-4">
                    {selectedColors.map((color, index) => (
                      <div
                        key={index}
                        style={{ backgroundColor: color }}
                        className="w-10 h-10 rounded-full border cursor-pointer"
                        title="Click to remove"
                        onClick={() => removeColor(color)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Pricing Details</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4">
                  <form>
                    <label for="product-price" class="form-label">
                      Price
                    </label>
                    <div class="input-group mb-3">
                      <span class="input-group-text fs-16">
                        {/* <i class="fas fas-naira-sign"></i> */}₦
                      </span>
                      <input
                        type="number"
                        id="product-price"
                        class="form-control"
                        placeholder="000"
                        value={values.price || ''}
                        onChange={handleChange}
                        name="price"
                        style={{
                          border: errors.price && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
                <div class="col-lg-4">
                  <form>
                    <label for="product-discount" class="form-label">
                      Discount
                    </label>
                    <div class="input-group mb-3">
                      <span class="input-group-text fs-20">
                        <i class="bx bxs-discount"></i>
                      </span>
                      <input
                        type="number"
                        id="product-discount"
                        class="form-control"
                        placeholder="000"
                        value={values.discount || ''}
                        onChange={handleChange}
                        name="discount"
                        style={{
                          border: errors.discount && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
                <div class="col-lg-4">
                  <form>
                    <label for="product-tex" class="form-label">
                      Tex
                    </label>
                    <div class="input-group mb-3">
                      <span class="input-group-text fs-20">
                        <i class="bx bxs-file-txt"></i>
                      </span>
                      <input
                        type="number"
                        id="product-tex"
                        class="form-control"
                        placeholder="000"
                        value={values.tex_price || ''}
                        onChange={handleChange}
                        name="tex_price"
                        style={{
                          border: errors.tex_price && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              {/* <div class="col-lg-2">
                <a href="#!" class="btn btn-outline-secondary w-100">
                  Create Product
                </a>
              </div> */}
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {product_loader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Create Product</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Create_Product;
